module.exports = __webpack_public_path__ + "static/media/tampabaywave-logo.32818783.png";